"use strict";
/**
 * @buildwithflux/app-flags
 *
 * Internal feature flag and experimentation system.
 *
 * This package provides:
 * - Type-safe flag definitions with Zod schemas (CODE layer)
 * - Flag programs with targeting rules (DATA layer)
 * - Pure evaluation engine with DAG support for flag dependencies
 * - Tri-state evaluation results (resolved/pending/error)
 * - Experiment run model with deficit-based allocation
 * - Sparse overlay solver for efficient storage
 * - Segment-based targeting with automatic polarity optimization
 * - Rollout percentage support with deterministic bucketing
 * - Context propagation types for Firestore storage
 *
 * Architecture: See ARCHITECTURE.md for full specification.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
// Type definitions (CODE layer)
tslib_1.__exportStar(require("./definitions"), exports);
tslib_1.__exportStar(require("./context"), exports);
tslib_1.__exportStar(require("./rules"), exports);
tslib_1.__exportStar(require("./evaluation"), exports);
// Evaluation engine
tslib_1.__exportStar(require("./conditions"), exports);
tslib_1.__exportStar(require("./dag"), exports);
tslib_1.__exportStar(require("./segments"), exports);
tslib_1.__exportStar(require("./engine"), exports);
// Experiment run model
tslib_1.__exportStar(require("./experiments"), exports);
// Sparse overlay solver
tslib_1.__exportStar(require("./sparse-overlay"), exports);
// Firestore integration
tslib_1.__exportStar(require("./firestore"), exports);
// Example definitions (for testing and documentation)
tslib_1.__exportStar(require("./examples"), exports);
//# sourceMappingURL=index.js.map